"use client"

import Link from "next/link"
import { Menu } from "lucide-react"
import { useState } from "react"

import { Logo } from "@/components/Logo"
import { cn } from "@/lib/utils"

import { getAppSignInUrl, NAV_LINKS } from "./landing/content"

export function Navigation() {
  const signInUrl = getAppSignInUrl()
  const [open, setOpen] = useState(false)

  return (
    <header className="w-full bg-[var(--paper,#fafaf9)]">
      <div className="mx-auto flex max-w-[1200px] items-center gap-6 px-4 py-5 sm:gap-10 sm:px-8">
        <Link href="/" className="flex shrink-0 items-center gap-2.5 text-stone-800" aria-label="Authorythm home">
          <Logo
            gradientFrom="#e11d48"
            gradientTo="#db2777"
            variant="gradient"
            size="sm"
            className="h-[34px] w-auto"
          />
          <span className="text-lg font-bold tracking-[-0.01em]">authorythm</span>
        </Link>

        <nav className="ml-auto hidden items-center gap-7 text-sm font-medium md:flex">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className="text-stone-600 transition-colors hover:text-stone-800"
            >
              {link.label}
            </Link>
          ))}
          <a
            href="/#signup"
            className="inline-flex items-center rounded-[14px] bg-rose-600 px-[18px] py-[9px] text-sm font-semibold text-white transition-colors hover:bg-rose-700"
          >
            Join the waitlist
          </a>
        </nav>

        <button
          type="button"
          className="ml-auto text-stone-800 md:hidden"
          aria-label="Open menu"
          onClick={() => setOpen((v) => !v)}
        >
          <Menu className="h-8 w-8" />
        </button>
      </div>

      {open ? (
        <div className="border-t border-stone-200 px-4 py-4 md:hidden">
          <div className="flex flex-col gap-3">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="py-2 text-sm font-medium text-stone-700"
              >
                {link.label}
              </Link>
            ))}
            <a
              href="/#signup"
              onClick={() => setOpen(false)}
              className={cn(
                "mt-2 inline-flex justify-center rounded-[14px] bg-rose-600 px-4 py-3 text-sm font-semibold text-white"
              )}
            >
              Join the waitlist
            </a>
            <Link href="/contact" onClick={() => setOpen(false)} className="py-2 text-sm text-stone-500">
              Contact
            </Link>
            <a href={signInUrl} className="py-2 text-sm text-stone-500">
              Sign in
            </a>
          </div>
        </div>
      ) : null}
    </header>
  )
}
